import {createContext, useContext} from 'react';

type FormContextType = {
    values: Record<string, any>;
    setFieldValue: (name: string, value: any) => void;
};

type FieldContextType = {
    name: string;
    id: string;
    warningMessage: string | null | undefined;
    warningMessageId: string;
};

export const FormContext = createContext<FormContextType | null>(null);
export const FieldContext = createContext<FieldContextType | null>(null);

export const useFormContext = () => {
    const ctx = useContext(FormContext);

    if (!ctx) throw new Error('useFormContext must be within AppForm');
    return ctx;
};

export const useFieldContext = () => {
    const ctx = useContext(FieldContext);

    if (!ctx) throw new Error('useFieldContext must be within AppForm.Field');
    return ctx;
};
